<template>
  <div>


    <div class="d-print-none d-flex justify-content-center align-items-center p-3">

      <t-button class="mr-3" primary submit-fake :sending="loading" :enable-loader="loading" :disabled="busy"
                @click="exportWordFromRenderedHtml()">
        <b-icon-file-word class="mr-2"/>
        Download Arquivo Word
      </t-button>

    </div>

    <div class="d-print-none d-flex justify-content-center">
      <b-alert
          v-model="copyAlert.show"
          :variant="copyAlert.variant"
          dismissible
          class="w-100"
          style="max-width: 1000px;"
      >
        <span v-html="copyAlert.message"></span>
      </b-alert>
    </div>

    <div id="container_report">

      <div class="h-100-header d-flex justify-content-center align-items-center" v-if="busy">
        <div class="loader">
          <div class="ball-scale-multiple">
            <div style="background-color: rgb(51,51,51);"></div>
            <div style="background-color: rgb(51,51,51);"></div>
            <div style="background-color: rgb(51,51,51);"></div>
          </div>
        </div>
      </div>

      <transition mode="out-in" enter-active-class="animated fadeIn">
        <div v-show="!busy" class="fadeIn" id="content-report" ref="contentReport">
          <slot></slot>
        </div>
      </transition>

    </div>

    <div
        ref="contentReportWord"
        style="position:absolute; left:-99999px; top:-99999px;">
    </div>

  </div>
</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ui from "@/assets/scripts/ui";
import ReportEvidenceDesignType from "@/model/types/modules/checklist/ReportEvidenceDesignType";
import {
  Document,
  Packer,
  Paragraph,
  PageBreak,
  TextRun,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  VerticalAlign,
  AlignmentType,
  HeadingLevel,
  ShadingType,
  BorderStyle,
  TableLayoutType
} from "docx";

import {saveAs} from "file-saver";

export default {
  mixins: [pageDefaultMixin],
  name: 'WordCopyView',
  data() {
    return {
      copyAlert: {
        show: false,
        variant: "success",
        message: ""
      },
      copyAlertTimer: null,
      loading: false,
    }
  },
  props: {
    busy: Boolean,
    title: {
      required: true,
      type: String,
    },
  },
  methods: {

    debugPageBreak(text) {
      return new Paragraph({
        children: [
          new TextRun({
            text: text,
            font: "Arial",
            size: 18,
            bold: true,
            color: "FF0000"
          })
        ]
      });
    },

    async exportWordFromRenderedHtml() {
      this.prepareWordHtml();
      this.loading = true;

      try {
        const root = this.$refs.contentReportWord;
        if (!root) {
          this.loading = false;
          return;
        }

        const masterChildren = [];
        const reportBlocks = root.querySelectorAll('[data-report-block="1"]');

        for (const reportBlock of reportBlocks) {
          const titleEl = reportBlock.querySelector('[data-report-title="1"]');
          const titleText = titleEl ? titleEl.innerText.trim() : "";

          const breakContainers = reportBlock.querySelectorAll('[data-break-container="1"]');

          for (let i = 0; i < breakContainers.length; i++) {
            const breakContainer = breakContainers[i];

            // Título apenas na primeira página do bloco
            if (titleText && i === 0) {
              masterChildren.push(
                  new Paragraph({
                    heading: HeadingLevel.HEADING_2,
                    spacing: {after: 200},
                    children: [
                      new TextRun({
                        text: titleText,
                        bold: true,
                        font: "Arial",
                        size: 28,
                        color: "000000"
                      })
                    ]
                  })
              );
            }

            const tableEl = breakContainer.querySelector("table");
            if (tableEl) {

              const docxResult = await this.convertHtmlTableToDocx(tableEl);

              if (Array.isArray(docxResult)) {
                masterChildren.push(...docxResult);
              } else {
                masterChildren.push(docxResult);
              }

              /*const docxTable = await this.convertHtmlTableToDocx(tableEl);
              masterChildren.push(docxTable);*/
            }

            // Quebra entre páginas internas do mesmo bloco
            if (i < breakContainers.length - 1) {

              /*
              masterChildren.push(
                this.debugPageBreak("DEBUG: Quebrar Página interna - bloco com " + breakContainers.length + " páginas - índice " + i)
              );
              */

              masterChildren.push(
                  new Paragraph({
                    children: [new PageBreak()]
                  })
              );
            }
          }

          // Quebra entre blocos/ambientes
          if (breakContainers.length > 0) {
            masterChildren.push(
                new Paragraph({
                  children: [new PageBreak()]
                })
            );
          }
        }

        // Remove a última quebra de página, se existir
        if (
            masterChildren.length > 0 &&
            masterChildren[masterChildren.length - 1] instanceof Paragraph
        ) {
          masterChildren.pop();
        }

        if (!masterChildren.length) {
          alert("Nenhum conteúdo encontrado para exportação.");
          this.loading = false;
          return;
        }


        //Desabilitado em 12/05/2026, pois ao criar uma tabela master mata a quebra de páginas.
        //const masterTable = this.createMasterTable(masterChildren);


        const doc = new Document({
          sections: [
            {
              properties: {
                page: {
                  margin: {
                    top: 1134,
                    right: 1134,
                    bottom: 1134,
                    left: 1134
                  }
                }
              },
              children: masterChildren //modo antigo [masterTable]
            }
          ]
        });

        const blob = await Packer.toBlob(doc);
        saveAs(blob, "relatorio-fotografico.docx");
      } finally {
        this.loading = false;
      }
    },

    createMasterTable(children) {
      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        layout: "fixed",
        alignment: AlignmentType.CENTER,
        cellSpacing: 0,
        borders: {
          top: {size: 0, color: "FFFFFF"},
          bottom: {size: 0, color: "FFFFFF"},
          left: {size: 0, color: "FFFFFF"},
          right: {size: 0, color: "FFFFFF"},
          insideHorizontal: {size: 0, color: "FFFFFF"},
          insideVertical: {size: 0, color: "FFFFFF"}
        },
        rows: [
          new TableRow({
            children: [
              new TableCell({
                width: {
                  size: 100,
                  type: WidthType.PERCENTAGE
                },
                borders: {
                  top: {size: 0, color: "FFFFFF"},
                  bottom: {size: 0, color: "FFFFFF"},
                  left: {size: 0, color: "FFFFFF"},
                  right: {size: 0, color: "FFFFFF"}
                },
                margins: {
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0
                },
                children: children
              })
            ]
          })
        ]
      });
    },

    async convertHtmlTableToDocx(tableEl) {

      const layout = parseInt(
          tableEl.getAttribute("data-report-layout")
      );


      switch (layout) {

        case ReportEvidenceDesignType.type.DEFAULT:
          return await this.convertSimplePhotoTableToDocx(tableEl);

        case ReportEvidenceDesignType.type.TEXT_OVERLAY_TOP:
          return await this.convertTextOverlayTopTableToDocx(tableEl);

        case ReportEvidenceDesignType.type.LIGHT_BORDER_BOTTOM_TEXT:
          return await this.convertLightBorderBottomTextTableToDocx(tableEl);

        case ReportEvidenceDesignType.type.HIGHLIGHT_PRESENTATION:
          return await this.convertHighlightPresentationTableToDocx(tableEl);

        case ReportEvidenceDesignType.type.TECHNICAL_HEADER_BORDER:
          return await this.convertTechnicalPhotoTableToDocx(tableEl);

        case ReportEvidenceDesignType.type.TECHNICAL_THICK_BORDER:
          return await this.convertTechnicalThickBorderTableToDocx(tableEl);

        default:
          return await this.convertSimplePhotoTableToDocx(tableEl);

      }

    },

    async convertSimplePhotoTableToDocx(tableEl) {

      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];

        for (const cellEl of cellEls) {
          const children = [];

          const imgEl = cellEl.querySelector("img");
          const captionEl = cellEl.querySelector('[data-report-caption="1"]');


          if (imgEl) {
            const imageRun = await this.convertImageElToImageRun(imgEl);

            children.push(
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  children: [imageRun]
                })
            );
          }


          if (captionEl) {
            const caption = captionEl.innerText.trim();


            children.push(
                new Paragraph({
                  alignment: AlignmentType.CENTER,
                  spacing: {before: 100},
                  children: [
                    new TextRun({
                      text: caption,
                      font: "Arial",
                      size: 16
                    })
                  ]
                })
            );
          }

          if (!children.length) {
            children.push(new Paragraph(""));
          }


          const paddingTop = this.pxToTwip(
              cellEl.getAttribute("data-table-cell-padding-top") || "10px"
          );
          const paddingBottom = this.pxToTwip(
              cellEl.getAttribute("data-table-cell-padding-bottom") || "10px"
          );

          cells.push(
              new TableCell({
                width: {
                  size: 50,
                  type: WidthType.PERCENTAGE
                },
                margins: {
                  top: paddingTop,
                  bottom: paddingBottom,
                  left: 80,
                  right: 80
                },
                borders: {
                  top: {size: 0, color: "FFFFFF"},
                  bottom: {size: 0, color: "FFFFFF"},
                  left: {size: 0, color: "FFFFFF"},
                  right: {size: 0, color: "FFFFFF"}
                },
                children: children
              })
          );
        }

        rows.push(
            new TableRow({
              children: cells
            })
        );
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        cellSpacing: 0,
        borders: {
          top: {size: 0, color: "FFFFFF"},
          bottom: {size: 0, color: "FFFFFF"},
          left: {size: 0, color: "FFFFFF"},
          right: {size: 0, color: "FFFFFF"},
          insideHorizontal: {size: 0, color: "FFFFFF"},
          insideVertical: {size: 0, color: "FFFFFF"}
        },
        rows: rows
      });
    },


    async convertTextOverlayTopTableToDocx(tableEl) {
      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];



      const createEmptyParagraph = () => new Paragraph("");

      const createCellBorders = () => ({
        top: this.getDocxBorderNone(),
        bottom: this.getDocxBorderNone(),
        left: this.getDocxBorderNone(),
        right: this.getDocxBorderNone()
      });

      const createTextParagraph = (el, options = {}) => {
        return new Paragraph({
          alignment: options.alignment || AlignmentType.CENTER,

          indent: {
            left: options.leftIndent ?? 80,
            right: options.rightIndent ?? 80
          },

          spacing: {
            before: options.before ?? 0,
            after: options.after ?? 80,
            line: options.line ?? 240
          },

          children: this.getRunsFromHtml(el, {
            size: options.size || 18
          })
        });
      };

      const createImageParagraph = async (imgEl) => {
        const imageRun = await this.convertImageElToImageRun(imgEl);

        return new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 200,
            after: 400
          },
          children: [imageRun]
        });
      };

      const createPhotoTableCell = (cellEl, children) => {
        const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);

        return new TableCell({
          columnSpan: colspan,

          width: {
            size: colspan === 2 ? 100 : 50,
            type: WidthType.PERCENTAGE
          },

          margins: {
            top: 0,
            bottom: 0,
            left: 80,
            right: 80
          },

          borders: createCellBorders(),

          children: children.length ? children : [createEmptyParagraph()]
        });
      };

      const createEmptyPhotoTableCell = () => {
        return new TableCell({
          width: {
            size: 50,
            type: WidthType.PERCENTAGE
          },
          borders: createCellBorders(),
          children: [createEmptyParagraph()]
        });
      };

      const createPhotoCellChildren = async (cellEl) => {
        const children = [];

        const headerEl = cellEl.querySelector('[data-report-photo-header="1"]');
        const imgEl = cellEl.querySelector('[data-report-photo-image="1"] img');

        if (headerEl) {
          children.push(
              createTextParagraph(headerEl, {
                alignment: AlignmentType.CENTER,
                size: 18,
                bold: true,
                leftIndent: 40,
                rightIndent: 40,
                before: 0,
                after: 80
              })
          );
        }

        if (imgEl) {
          children.push(await createImageParagraph(imgEl));
        }

        return children;
      };

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];

        for (const cellEl of cellEls) {
          const isEmpty = cellEl.getAttribute("data-report-photo-card") === "empty";

          if (isEmpty) {
            cells.push(createEmptyPhotoTableCell());
            continue;
          }

          const children = await createPhotoCellChildren(cellEl);
          cells.push(createPhotoTableCell(cellEl, children));
        }

        rows.push(
            new TableRow({
              cantSplit: true,
              children: cells
            })
        );
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        columnWidths: [5000, 5000],
        layout: TableLayoutType.FIXED,
        cellSpacing: 0,
        borders: {
          top: this.getDocxBorderNone(),
          bottom: this.getDocxBorderNone(),
          left: this.getDocxBorderNone(),
          right: this.getDocxBorderNone(),
          insideHorizontal: this.getDocxBorderNone(),
          insideVertical: this.getDocxBorderNone()
        },
        rows
      });
    },


    async convertLightBorderBottomTextTableToDocx(tableEl) {


      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];

      const borderLight = {
        style: BorderStyle.SINGLE,
        size: 4,
        color: "BDBDBD"
      };


      const createEmptyParagraph = () => new Paragraph("");

      const createCellBorders = () => ({
        top: borderLight,
        bottom: borderLight,
        left: borderLight,
        right: borderLight
      });


      const createTextParagraph = (el, options = {}) => {
        return new Paragraph({
          alignment: options.alignment || AlignmentType.CENTER,
          spacing: {
            before: options.before ?? 40,
            after: options.after ?? 40,
            line: options.line ?? 240
          },
          children: this.getRunsFromHtml(el, {
            size: options.size || 16
          })
        });
      };

      const createImageParagraph = async (imgEl) => {
        const imageRun = await this.convertImageElToImageRun(imgEl);

        return new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 40,
            after: 40
          },
          children: [imageRun]
        });
      };

      const createPhotoTableCell = (cellEl, children) => {
        const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);

        return new TableCell({
          columnSpan: colspan,
          width: {
            size: colspan === 2 ? 100 : 50,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 40,
            bottom: 40,
            left: 40,
            right: 40
          },
          borders: createCellBorders(),
          verticalAlign: VerticalAlign.TOP,
          children: children.length ? children : [createEmptyParagraph()]
        });
      };

      const createEmptyPhotoTableCell = () => {
        return new TableCell({
          width: {
            size: 50,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 40,
            bottom: 40,
            left: 40,
            right: 40
          },
          borders: createCellBorders(),
          children: [createEmptyParagraph()]
        });
      };

      const createPhotoCellChildren = async (cellEl) => {
        const children = [];

        const imgEl = cellEl.querySelector('[data-report-photo-image="1"] img');
        const headerEl = cellEl.querySelector('[data-report-photo-header="1"]');

        if (imgEl) {
          children.push(await createImageParagraph(imgEl));
        }

        if (headerEl) {
          children.push(
              createTextParagraph(headerEl, {
                alignment: AlignmentType.CENTER,
                size: 16,
                bold: true,
                before: 20,
                after: 20
              })
          );
        }

        return children;
      };

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];

        for (const cellEl of cellEls) {
          const isEmpty = cellEl.getAttribute("data-report-photo-card") === "empty";

          if (isEmpty) {
            cells.push(createEmptyPhotoTableCell());
            continue;
          }

          const children = await createPhotoCellChildren(cellEl);
          cells.push(createPhotoTableCell(cellEl, children));
        }

        rows.push(
            new TableRow({
              cantSplit: true,
              children: cells
            })
        );
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        columnWidths: [5000, 5000],
        layout: TableLayoutType.FIXED,
        cellSpacing: 0,
        borders: {
          top: this.getDocxBorderNone(),
          bottom: this.getDocxBorderNone(),
          left: this.getDocxBorderNone(),
          right: this.getDocxBorderNone(),
          insideHorizontal: this.getDocxBorderNone(),
          insideVertical: this.getDocxBorderNone()
        },
        rows
      });
    },


    async convertHighlightPresentationTableToDocx(tableEl) {
      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];


      const createEmptyParagraph = () => new Paragraph("");

      const createCellBorders = () => ({
        top: this.getDocxBorderBlack(6),
        bottom: this.getDocxBorderBlack(6),
        left: this.getDocxBorderBlack(6),
        right: this.getDocxBorderBlack(6)
      });

      const createTextParagraph = (el, options = {}) => {
        return new Paragraph({
          alignment: options.alignment || AlignmentType.LEFT,
          shading: options.shading || undefined,
          indent: {
            left: options.leftIndent ?? 80,
            right: options.rightIndent ?? 80
          },
          spacing: {
            before: options.before ?? 0,
            after: options.after ?? 0,
            line: options.line ?? 240
          },
          children: this.getRunsFromHtml(el, {
            size: options.size || 16
          })
        });
      };

      const createImageParagraph = async (imgEl) => {
        const imageRun = await this.convertImageElToImageRun(imgEl);

        return new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 160,
            after: 160
          },
          children: [imageRun]
        });
      };

      const createPhotoTableCell = (cellEl, children) => {
        const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);

        return new TableCell({
          columnSpan: colspan,
          width: {
            size: colspan === 2 ? 100 : 50,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          borders: createCellBorders(),
          children: children.length ? children : [createEmptyParagraph()]
        });
      };

      const createEmptyPhotoTableCell = () => {
        return new TableCell({
          width: {
            size: 50,
            type: WidthType.PERCENTAGE
          },
          borders: createCellBorders(),
          children: [createEmptyParagraph()]
        });
      };

      const createPhotoCellChildren = async (cellEl) => {
        const children = [];

        const fullTitle = cellEl.getAttribute("data-report-full-title") === "1";

        if (fullTitle) {
          children.push(
              new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {
                  before: 80,
                  after: 80
                },
                children: this.getRunsFromHtml(cellEl, {
                  size: 18
                })
              })
          );

          return children;
        }

        const headerEl = cellEl.querySelector('[data-report-photo-header="1"]');
        const imgEl = cellEl.querySelector('[data-report-photo-image="1"] img');
        const statusEl = cellEl.querySelector('[data-report-photo-status="1"]');
        const lineEls = cellEl.querySelectorAll('[data-report-photo-line="1"]');
        const observationEl = cellEl.querySelector('[data-report-photo-observation="1"]');

        const createHeaderTable = (headerEl) => {
          return new Table({
            width: {
              size: 100,
              type: WidthType.PERCENTAGE
            },
            layout: TableLayoutType.FIXED,
            cellSpacing: 0,
            borders: {
              top: this.getDocxBorderNone(),
              bottom: this.getDocxBorderNone(),
              left: this.getDocxBorderNone(),
              right: this.getDocxBorderNone(),
              insideHorizontal: this.getDocxBorderNone(),
              insideVertical: this.getDocxBorderNone(),
            },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    shading: {
                      type: ShadingType.CLEAR,
                      fill: "E3E3E3"
                    },
                    margins: {
                      top: 60,
                      bottom: 60,
                      left: 60,
                      right: 60
                    },
                    borders: {
                      top: this.getDocxBorderNone(),
                      bottom: this.getDocxBorderNone(),
                      left: this.getDocxBorderNone(),
                      right: this.getDocxBorderNone(),
                    },
                    children: [
                      new Paragraph({
                        alignment: AlignmentType.RIGHT,
                        spacing: {
                          before: 0,
                          after: 0,
                          line: 240
                        },
                        children: this.getRunsFromHtml(headerEl, {
                          size: 16
                        })
                      })
                    ]
                  })
                ]
              })
            ]
          });
        };

        if (headerEl) {

          children.push(createHeaderTable(headerEl));

          /*children.push(
              createTextParagraph(headerEl, {
                alignment: AlignmentType.RIGHT,
                shading: {
                  type: ShadingType.CLEAR,
                  fill: "CFCFCF"
                },
                size: 16,
                leftIndent: 40,
                rightIndent: 40,
                before: 0,
                after: 0
              })
          );*/
        }

        if (imgEl) {
          children.push(await createImageParagraph(imgEl));
        }

        if (statusEl) {
          children.push(
              createTextParagraph(statusEl, {
                alignment: AlignmentType.LEFT,
                size: 18,
                leftIndent: 120,
                rightIndent: 80,
                before: 80,
                after: 80,
                line: 240
              })
          );
        }

        for (const lineEl of lineEls) {
          children.push(
              createTextParagraph(lineEl, {
                alignment: AlignmentType.LEFT,
                size: 16,
                leftIndent: 120,
                rightIndent: 80,
                before: 0,
                after: 40
              })
          );
        }

        if (observationEl) {
          children.push(
              createTextParagraph(observationEl, {
                alignment: AlignmentType.LEFT,
                size: 16,
                leftIndent: 120,
                rightIndent: 80,
                before: 0,
                after: 120
              })
          );
        }

        return children;
      };

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];

        for (const cellEl of cellEls) {
          const isEmpty = cellEl.getAttribute("data-report-photo-card") === "empty";

          if (isEmpty) {
            cells.push(createEmptyPhotoTableCell());
            continue;
          }

          const children = await createPhotoCellChildren(cellEl);
          cells.push(createPhotoTableCell(cellEl, children));
        }

        rows.push(
            new TableRow({
              cantSplit: true,
              children: cells
            })
        );
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        columnWidths: [5000, 5000],
        layout: TableLayoutType.FIXED,
        cellSpacing: 0,
        borders: {
          top: this.getDocxBorderBlack(),
          bottom: this.getDocxBorderBlack(),
          left: this.getDocxBorderBlack(),
          right: this.getDocxBorderBlack(),
          insideHorizontal: this.getDocxBorderBlack(),
          insideVertical: this.getDocxBorderBlack()
        },
        rows
      });
    },


    async convertTechnicalThickBorderTableToDocx(tableEl) {
      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];




      const createEmptyParagraph = () => new Paragraph("");

      const createTextParagraph = (el, options = {}) => {
        return new Paragraph({
          alignment: options.alignment || AlignmentType.CENTER,
          spacing: {
            before: options.before ?? 0,
            after: options.after ?? 0,
            line: options.line ?? 240
          },
          children: this.getRunsFromHtml(el, {
            size: options.size || 18
          })
        });
      };

      const createImageParagraph = async (imgEl) => {
        const imageRun = await this.convertImageElToImageRun(imgEl);

        return new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 160,
            after: 160
          },
          children: [imageRun]
        });
      };

      const createCellBorders = () => ({
        top: this.getDocxBorderBlack(),
        bottom: this.getDocxBorderBlack(),
        left: this.getDocxBorderBlack(),
        right: this.getDocxBorderBlack()
      });

      const createInnerImageCell = async (imgEl) => {
        return new TableCell({
          columnSpan: 3,
          width: {
            size: 100,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          borders: {
            top: this.getDocxBorderNone(),
            bottom: this.getDocxBorderBlack(),
            left: this.getDocxBorderNone(),
            right: this.getDocxBorderNone()
          },
          verticalAlign: VerticalAlign.CENTER,
          children: imgEl ? [await createImageParagraph(imgEl)] : [createEmptyParagraph()]
        });
      };

      const createInnerFooterCell = (el, width, options = {}) => {
        return new TableCell({
          width: {
            size: width,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 80,
            bottom: 80,
            left: 40,
            right: 40
          },
          borders: {
            top: this.getDocxBorderNone(),
            bottom: this.getDocxBorderNone(),
            left: options.noLeftBorder ? this.getDocxBorderNone() : this.getDocxBorderBlack(),
            right: options.noRightBorder ? this.getDocxBorderNone() : this.getDocxBorderBlack(),
          },
          verticalAlign: VerticalAlign.CENTER,
          children: [
            createTextParagraph(el, {
              alignment: AlignmentType.CENTER,
              size: 16,
              bold: true
            })
          ]
        });
      };

      const createInnerPhotoTable = async (cellEl) => {
        const imgEl = cellEl.querySelector('[data-report-photo-image="1"] img');
        let footerLabelEl = cellEl.querySelector('[data-report-photo-footer-label="1"]');
        const footerNumberEl = cellEl.querySelector('[data-report-photo-footer-number="1"]');
        let footerDescriptionEl = cellEl.querySelector('[data-report-photo-footer-description="1"]');


        return new Table({
          width: {
            size: 100,
            type: WidthType.PERCENTAGE
          },
          columnWidths: [1000, 1000, 8000],
          layout: TableLayoutType.FIXED,
          cellSpacing: 0,
          indent: {
            size: 0,
            type: WidthType.DXA
          },
          borders: {
            top: this.getDocxBorderNone(),
            bottom: this.getDocxBorderBlack(),
            left: this.getDocxBorderNone(),
            right: this.getDocxBorderNone(),
            insideHorizontal: this.getDocxBorderBlack(),
            insideVertical: this.getDocxBorderBlack(),
          },
          rows: [
            new TableRow({
              cantSplit: true,
              children: [
                await createInnerImageCell(imgEl)
              ]
            }),
            new TableRow({
              cantSplit: true,
              children: [
                createInnerFooterCell(footerLabelEl, 10, {noLeftBorder: true}),
                createInnerFooterCell(footerNumberEl, 10),
                createInnerFooterCell(footerDescriptionEl, 80, {noRightBorder: true})
              ]
            })
          ]
        });
      };

      const createPhotoTableCell = async (cellEl, cellsInRow) => {
        const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);
        const widthSize = colspan > 1 ? 100 : Math.floor(100 / cellsInRow);

        return new TableCell({
          columnSpan: colspan,
          width: {
            size: widthSize,
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          borders: createCellBorders(),
          verticalAlign: VerticalAlign.TOP,
          children: [
            await createInnerPhotoTable(cellEl)
          ]
        });
      };

      const createEmptyPhotoTableCell = (cellsInRow) => {
        return new TableCell({
          width: {
            size: Math.floor(100 / cellsInRow),
            type: WidthType.PERCENTAGE
          },
          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          borders: createCellBorders(),
          children: [createEmptyParagraph()]
        });
      };

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];
        const cellsInRow = cellEls.length || 1;

        for (const cellEl of cellEls) {
          const isEmpty = cellEl.getAttribute("data-report-photo-card") === "empty";

          if (isEmpty) {
            cells.push(createEmptyPhotoTableCell(cellsInRow));
            continue;
          }

          cells.push(await createPhotoTableCell(cellEl, cellsInRow));
        }

        if (cells.length) {
          rows.push(
              new TableRow({
                cantSplit: true,
                children: cells
              })
          );
        }
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        columnWidths: [5000, 5000],
        layout: TableLayoutType.FIXED,
        cellSpacing: 0,
        borders: {
          top: this.getDocxBorderBlack(),
          bottom: this.getDocxBorderBlack(),
          left: this.getDocxBorderBlack(),
          right: this.getDocxBorderBlack(),
          insideHorizontal: this.getDocxBorderBlack(),
          insideVertical: this.getDocxBorderBlack(),
        },
        rows
      });
    },


    async convertTechnicalPhotoTableToDocx(tableEl) {
      const rowEls = tableEl.querySelectorAll(":scope > tbody > tr, :scope > tr");
      const rows = [];


      const paragraphBottomBorder = {
        bottom: {
          color: "000000",
          size: 4,
          style: BorderStyle.SINGLE
        }
      };

      const createEmptyParagraph = () => new Paragraph("");

      const createCellBorders = () => ({
        top: this.getDocxBorderBlack(8),
        bottom: this.getDocxBorderBlack(8),
        left: this.getDocxBorderBlack(8),
        right: this.getDocxBorderBlack(8)
      });

      const createTextParagraph = (el, options = {}) => {
        return new Paragraph({
          alignment: options.alignment || AlignmentType.LEFT,
          shading: options.shading || undefined,

          indent: {
            left: options.leftIndent ?? 80,
            right: options.rightIndent ?? 80
          },

          spacing: {
            before: options.before ?? 0,
            after: options.after ?? 0,
            line: options.line ?? 240
          },

          border: options.noBottomBorder ? undefined : paragraphBottomBorder,

          children: this.getRunsFromHtml(el, {
            size: options.size || 18
          })
        });
      };

      const createImageParagraph = async (imgEl) => {
        const imageRun = await this.convertImageElToImageRun(imgEl);

        return new Paragraph({
          alignment: AlignmentType.CENTER,
          spacing: {
            before: 160,
            after: 160
          },
          children: [imageRun]
        });
      };

      const createPhotoTableCell = (cellEl, children) => {

        const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);

        return new TableCell({
          columnSpan: colspan,

          width: {
            size: colspan === 2 ? 100 : 50,
            type: WidthType.PERCENTAGE
          },

          margins: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },

          borders: createCellBorders(),

          children: children.length ? children : [createEmptyParagraph()]
        });
      };

      const createEmptyPhotoTableCell = () => {
        return new TableCell({
          width: {
            size: 50,
            type: WidthType.PERCENTAGE
          },
          borders: createCellBorders(),
          children: [createEmptyParagraph()]
        });
      };

      const createPhotoCellChildren = async (cellEl) => {
        const children = [];


        const fullTitle = cellEl.getAttribute("data-report-full-title") === "1";

        if (fullTitle) {
          children.push(
              new Paragraph({
                alignment: AlignmentType.CENTER,
                spacing: {before: 80, after: 80},
                children: this.getRunsFromHtml(cellEl, {
                  size: 18
                })
              })
          );

          return children;
        }

        const headerEl = cellEl.querySelector('[data-report-photo-header="1"]');
        const lineEls = cellEl.querySelectorAll('[data-report-photo-line="1"]');
        const observationEl = cellEl.querySelector('[data-report-photo-observation="1"]');
        const imgEl = cellEl.querySelector('[data-report-photo-image="1"] img');

        const createHeaderTable = (headerEl) => {
          return new Table({
            width: {
              size: 100,
              type: WidthType.PERCENTAGE
            },
            layout: TableLayoutType.FIXED,
            cellSpacing: 0,
            borders: {
              top: this.getDocxBorderNone(),
              bottom: this.getDocxBorderNone(),
              left: this.getDocxBorderNone(),
              right: this.getDocxBorderNone(),
              insideHorizontal: this.getDocxBorderNone(),
              insideVertical: this.getDocxBorderNone(),
            },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    shading: {
                      type: ShadingType.CLEAR,
                      fill: "CFCFCF"
                    },
                    margins: {
                      top: 60,
                      bottom: 60,
                      left: 60,
                      right: 60
                    },
                    borders: {
                      top: this.getDocxBorderNone(),
                      bottom: this.getDocxBorderNone(),
                      left: this.getDocxBorderNone(),
                      right: this.getDocxBorderNone(),
                    },
                    children: [
                      new Paragraph({
                        alignment: AlignmentType.RIGHT,
                        spacing: {
                          before: 0,
                          after: 0,
                          line: 240
                        },
                        children: this.getRunsFromHtml(headerEl, {
                          size: 16
                        })
                      })
                    ]
                  })
                ]
              })
            ]
          });
        };

        if (headerEl) {
          children.push(createHeaderTable(headerEl));

          /*children.push(
              createTextParagraph(headerEl, {
                alignment: AlignmentType.RIGHT,
                shading: {
                  type: ShadingType.CLEAR,
                  fill: "CFCFCF"
                },
                size: 16,
                bold: true,
                leftIndent: 40,
                rightIndent: 40,
                before: 0,
                after: 0,
                noBottomBorder: true,
              })
          );*/
        }

        for (const lineEl of lineEls) {
          children.push(
              createTextParagraph(lineEl, {
                size: 16,
                leftIndent: 80,
                rightIndent: 80,
                before: 0,
                after: 0,
                noBottomBorder: true,
              })
          );
        }

        if (observationEl) {
          children.push(
              createTextParagraph(observationEl, {
                size: 16,
                leftIndent: 80,
                rightIndent: 40,
                before: 0,
                after: 80,
                noBottomBorder: true,
              })
          );
        }

        if (imgEl) {
          children.push(await createImageParagraph(imgEl));
        }

        return children;
      };

      for (const rowEl of rowEls) {
        const cellEls = rowEl.querySelectorAll(":scope > td, :scope > th");
        const cells = [];

        for (const cellEl of cellEls) {
          const isEmpty = cellEl.getAttribute("data-report-photo-card") === "empty";

          if (isEmpty) {
            cells.push(createEmptyPhotoTableCell());
            continue;
          }

          const children = await createPhotoCellChildren(cellEl);
          cells.push(createPhotoTableCell(cellEl, children));
        }

        rows.push(
            new TableRow({
              cantSplit: true,
              children: cells
            })
        );
      }

      return new Table({
        width: {
          size: 100,
          type: WidthType.PERCENTAGE
        },
        columnWidths: [5000, 5000],
        layout: TableLayoutType.FIXED,
        cellSpacing: 0,
        borders: {
          top: this.getDocxBorderBlack(),
          bottom: this.getDocxBorderBlack(),
          left: this.getDocxBorderBlack(),
          right: this.getDocxBorderBlack(),
          insideHorizontal: this.getDocxBorderBlack(),
          insideVertical: this.getDocxBorderBlack()
        },
        rows
      });
    },

    getDocxBorderNone() {
      return {
        style: BorderStyle.NONE,
        size: 0,
        color: "FFFFFF"
      };
    },

    getDocxBorderBlack(size = 12) {
      return {
        style: BorderStyle.SINGLE,
        size: size,
        color: "000000"
      };
    },

    getRunsFromHtml(el, options = {}) {
      const runs = [];

      if (!el) {
        return runs;
      }

      const processNode = (node, inherited = {}) => {
        if (node.nodeType === Node.TEXT_NODE) {

          let text = node.textContent.replace(/\s+/g, " ");

          if (options.uppercase) {
            text = text.toUpperCase();
          }

          if (text.trim()) {

            runs.push(
                new TextRun({
                  text,
                  font: inherited.font || options.font || "Arial",
                  size: inherited.size || options.size || 18,
                  bold: inherited.bold === true,
                  color: inherited.color || options.color || undefined
                })
            );
          }

          return;
        }

        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        const tag = node.tagName.toUpperCase();

        if (tag === "BR") {
          runs.push(
              new TextRun({
                text: "",
                break: 1
              })
          );
          return;
        }

        const next = { ...inherited };

        if (tag === "STRONG" || tag === "B") {
          next.bold = true;
        }

        const color = node.style && node.style.color ? node.style.color : "";

        if (color) {
          const hex = this.convertCssColorToHex(color);

          if (hex) {
            next.color = hex;
          }
        }

        const fontSize = node.style && node.style.fontSize ? node.style.fontSize : "";

        if (fontSize) {
          const px = parseInt(fontSize.replace("px", ""), 10);

          if (!isNaN(px)) {
            next.size = Math.round(px * 1.5);
          }
        }

        node.childNodes.forEach((child) => {
          processNode(child, next);
        });
      };

      el.childNodes.forEach((node) => {
        processNode(node, {
          bold: options.bold === true,
          size: options.size || 18,
          font: options.font || "Arial",
          color: options.color || undefined
        });
      });

      return runs;
    },


    convertCssColorToHex(color) {
      if (!color) return null;

      // rgb(229, 57, 53)
      if (color.startsWith("rgb")) {
        const nums = color.match(/\d+/g);
        if (!nums) return null;

        return nums
            .map(n => parseInt(n).toString(16).padStart(2, "0"))
            .join("")
            .toUpperCase();
      }

      // #e53935
      if (color.startsWith("#")) {
        return color.replace("#", "").toUpperCase();
      }

      return null;
    },

    pxToTwip(px) {
      if (!px) return 0;
      return Math.round(parseInt(px, 10) * 15);
    },

    async convertImageElToImageRun(imageEl) {
      const src = imageEl.getAttribute("src");
      const width = parseInt(imageEl.getAttribute("width"), 10) || 260;
      const height = parseInt(imageEl.getAttribute("height"), 10) || 173;

      const finalUrl = src + (src.indexOf("?") >= 0 ? "&" : "?") + "cors_test=1";

      const response = await fetch(finalUrl, {
        mode: "cors",
        cache: "no-store"
      });

      if (!response.ok) {
        throw new Error("Erro ao carregar imagem: " + response.status + " - " + src);
      }

      const arrayBuffer = await response.arrayBuffer();

      return new ImageRun({
        data: arrayBuffer,
        transformation: {
          width: width,
          height: height
        },
        type: 'jpg'
      });
    },

    async gerarTesteWord() {
      const doc = new Document({
        creator: "Onlaine",
        title: "Relatório Fotográfico",
        description: "Gerado automaticamente por www.onlaine.com.br",
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun("Teste relatório Onlaine")
                ]
              }),
              new Paragraph({
                children: [new PageBreak()]
              }),
              new Paragraph({
                children: [
                  new TextRun("Nova página funcionando!")
                ]
              })
            ]
          }
        ]
      });

      const blob = await Packer.toBlob(doc);
      saveAs(blob, "teste-pagebreak.docx");
    },


    showCopyAlert(variant, message) {

      // limpa timer anterior (evita fechar o alert novo)
      if (this.copyAlertTimer) {
        clearTimeout(this.copyAlertTimer);
        this.copyAlertTimer = null;
      }

      this.copyAlert.variant = variant;
      this.copyAlert.message = message;
      this.copyAlert.show = true;

      // fecha automaticamente após 5 segundos
      this.copyAlertTimer = setTimeout(() => {
        this.copyAlert.show = false;
        this.copyAlertTimer = null;
      }, 5000);
    },


    selectReportContent() {
      const el = this.$refs.contentReport;
      if (!el) return false;

      try {
        const range = document.createRange();
        range.selectNodeContents(el);

        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        // garante foco e visibilidade da selecao
        if (el.focus) el.focus();
        if (el.scrollIntoView) el.scrollIntoView({block: "center"});

        return true;
      } catch (e) {
        return false;
      }
    },

    async tryCopyToClipboard() {
      // 1) tenta execCommand primeiro (melhor chance de manter formatacao do HTML)
      try {
        if (document.execCommand) {
          const ok = document.execCommand("copy");
          if (ok) return {ok: true, method: "execCommand"};
        }
      } catch (e) {
        // continua
      }

      // 2) fallback: clipboard API (texto puro)
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          const sel = window.getSelection();
          const text = sel ? sel.toString() : "";
          if (!text) return {ok: false, reason: "empty"};

          await navigator.clipboard.writeText(text);
          return {ok: true, method: "clipboardText"};
        }
      } catch (e) {
        return {ok: false, reason: "blocked"};
      }

      return {ok: false, reason: "unsupported"};
    },

    downloadWordFromHtml() {

      this.prepareWordHtml()

      const el = this.$refs.contentReportWord;
      if (!el) return;


      let bodyHtml = el.innerHTML;

      // quebra de pagina para Word
      bodyHtml = bodyHtml.replace(
          /break-after\s*:\s*page\s*;?/gi,
          'page-break-before:always; mso-page-break-before:always;'
      );

      const html =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" ' +
          'xmlns:w="urn:schemas-microsoft-com:office:word" ' +
          'xmlns="http://www.w3.org/TR/REC-html40">' +
          '<head><meta charset="utf-8"></head><body>' +
          bodyHtml +
          '</body></html>';

      const blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'relatorio-fotos.doc';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },

    prepareWordHtml() {
      const source = this.$refs.contentReport;
      const target = this.$refs.contentReportWord;

      if (!source || !target) return;

      const clone = source.cloneNode(true);

      // remove elementos de UI
      const remove = clone.querySelectorAll('.no-print');
      remove.forEach(el => el.remove());

      target.innerHTML = clone.innerHTML;
    },

    async copyAll() {
      if (this.busy) return;

      const selected = this.selectReportContent();
      if (!selected) {
        this.showCopyAlert(
            "danger",
            "N&atilde;o foi poss&iacute;vel selecionar o conte&uacute;do automaticamente. Por favor clique no relat&oacute;rio e use <b>CTRL + A</b> e <b>CTRL + C</b>."
        );
        return;
      }

      const result = await this.tryCopyToClipboard();

      if (result.ok) {
        this.showCopyAlert(
            "success",
            "Conte&uacute;do copiado com sucesso. Agora no Word, use <b>CTRL + V</b> e selecione <b>Manter Formata&ccedil;&atilde;o Original.<br /><img alt=\"Manter formata&ccedil;&atilde;o original\" src=\"https://static.onlaine.com.br/images/copy-word.jpg\" /></b><br />\n" +
            "<br />Obs.: Pode demorar alguns minutos dependendo da quantidade de fotos."
        );
      } else {
        var motivo = "Seu navegador bloqueou a c&oacute;pia autom&aacute;tica.";
        if (result.reason === "empty") motivo = "N&atilde;o foi encontrado conte&uacute;do para copiar.";
        if (result.reason === "unsupported") motivo = "C&oacute;pia autom&aacute;tica n&atilde;o suportada neste navegador.";

        this.showCopyAlert(
            "warning",
            motivo + " Por favor use o modo manual: <b>CTRL + A</b> e depois <b>CTRL + C</b>."
        );
      }
    }

  },
  async mounted() {
    ui.setFavicon("document")
  },

}
</script>

<style>
.table thead th {
  text-align: center;
  vertical-align: middle;
}

body {
  background-color: #363636;
}

#container_report {
  max-width: 1000px;
  background-color: #FFFFFF;
  margin: auto;
  padding: 15px;
  height: calc(100vh - 100px);
  overflow: auto;
}

.report-landscape {
  max-width: 100%;
}

@media print {

  body {
    background-color: #FFFFFF;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  #container_report {
    height: 100%;
  }

  .apexcharts-toolbar {
    display: none !important;
  }

  @page {
    margin-top: 30px;
    margin-bottom: 20px;
  }

}
</style>
